import Alert from './alert';

(function ($) {
    const conditionalFields = $('[data-conditional-field]');
    conditionalFields.each(function () {
        const condField = $(this);
        const settings = JSON.parse(condField.attr('data-conditional-field'));

        const {
            is_toggleable,
            conditional_field_name,
            conditional_field_value,
            conditional_field_condition,
        } = settings;

        if (is_toggleable) {
            const condSelectEl = $(`select[name="${conditional_field_name}"]`);
            const condSelectElValue = condSelectEl.val();

            condSelectEl.on('select2:select', function (e) {
                const selVal = $(this).val();
                checkConditionalSelect(
                    condField,
                    conditional_field_value,
                    conditional_field_condition,
                    selVal
                );
            });

            checkConditionalSelect(
                condField,
                conditional_field_value,
                conditional_field_condition,
                condSelectElValue
            );
        }
    });

    function modifyFormDataConditionals(formData) {
        conditionalFields.each(function () {
            const condField = $(this);
            const settings = JSON.parse(
                condField.attr('data-conditional-field')
            );

            const {
                is_toggleable,
                conditional_field_name,
                conditional_field_value,
                conditional_field_condition,
            } = settings;

            if (is_toggleable) {
                const condSelectEl = $(
                    `select[name="${conditional_field_name}"]`
                );
                const condSelectElValue = condSelectEl.val();

                checkFormDataConditionals(
                    formData,
                    condField,
                    conditional_field_value,
                    conditional_field_condition,
                    condSelectElValue
                );
            }
        });
    }

    function checkFormDataConditionals(
        formData,
        field,
        fieldValue,
        condition,
        selectValue
    ) {
        const fieldName = field.attr('name');

        if (condition === 'equal' && selectValue !== fieldValue)
            formData.delete(fieldName);

        if (condition === 'not_equal' && selectValue === fieldValue)
            formData.delete(fieldName);
    }

    function checkConditionalSelect(field, fieldValue, condition, selectValue) {
        if (condition === 'equal') {
            if (selectValue === fieldValue) {
                field.closest('.form__field').removeClass('hidden');
            } else {
                field.closest('.form__field').addClass('hidden');
            }
        }

        if (condition === 'not_equal') {
            if (selectValue !== fieldValue) {
                field.closest('.form__field').removeClass('hidden');
            } else {
                field.closest('.form__field').addClass('hidden');
            }
        }
    }

    const resetOutputWrapper = (outputWrapper) => {
        outputWrapper.classList.remove('success');
        outputWrapper.classList.remove('error');
        outputWrapper.classList.remove('error');
        outputWrapper.textContent = "";
    }

    const showOutputWrapper = (outputWrapper, settings) => {
        const { title, error, success } = settings;

        if (error) {
            outputWrapper.classList.add("error");
        } else if (success) {
            outputWrapper.classList.add("success");
        } else {
            outputWrapper.classList.add("error");
        }

        outputWrapper.textContent = title;
    }

    $('.js-cf-form').on('submit', function (e) {
        e.preventDefault();

        const formLoader = this.querySelector(".loader");

        if (formLoader) formLoader.classList.add("active");

        const $form = $(this);
        let data = $form.serialize();
        const alertWrapper = $form[0].querySelector('.form-alert');
        const formOutputWrapper = $form.find(".output-wrapper");
       
        if (formOutputWrapper && formOutputWrapper.length > 0) {
            resetOutputWrapper(formOutputWrapper[0]);
        }

        $form.addClass('is-loading');

        const recaptchaKey = $form.find('#g-recaptcha').val();
        const formId = $form.attr('id');
        let formObject = document.getElementById(formId);
        const formData = new FormData(formObject);
        modifyFormDataConditionals(formData);

        const filesToUpload = $form.find('[type="file"]');

        grecaptcha.ready(function () {
            grecaptcha
                .execute(recaptchaKey, { action: 'submit' })
                .then(function (token) {
                    console.log('test');
                    formData.append('g_recaptcha_token', token);
                    formData.append('referer_site', window.location.href)

                    $.ajax({
                        type: 'post',
                        url: ajax.url,
                        data: formData,
                        processData: false,
                        contentType: false,
                        beforeSend: function () {
                            $('.js-cf-error').remove();
                            $('.form-field').removeClass('error');
                            $form
                                .find('.js-form-output')
                                .removeClass(
                                    'has-errors is-warning is-success'
                                );

                            $('.js-cf-form__status').removeClass('success');
                            $('.js-cf-form__status').hide();
                            $('.js-cf-form__status span').html('');
                        },
                        success: function (response) {
                            response = $.parseJSON(response);

                            let alert_data = {};

                            if (response.status == 'ERROR') {
                                $.each(
                                    response.errors.fields,
                                    function (key, value) {
                                        const $parent = $form
                                            .find(`[name="${key}"]`)
                                            .parents('.form-field');
                                        $parent.addClass('error');
                                        $parent.append(
                                            `<div class='js-cf-error form-error'>${value}</div>`
                                        );

                                        const multipleParent = $form // check for inputs with multiple values (eg. files)
                                            .find(`[name="${key}[]"]`)
                                            .parents('.form-field');

                                        multipleParent.addClass('error');
                                        multipleParent.append(
                                            `<div class='js-cf-error form-error'>${value}</div>`
                                        );
                                    }
                                );

                                
                                alert_data = {
                                    type: 'alert:show',
                                    title: response.errors.form,
                                    error: true,
                                };
                            } else if (response.status == 'WARNING') {
                                $form.find(':input:not([type=hidden]):not(:checkbox)').val('');
                                $form.find('textarea').val('');
                                $form
                                    .find('input[type="checkbox"]')
                                    .prop('checked', false);

                                 alert_data = {
                                    type: 'alert:show',
                                    title: response.errors.send_mail ? response.errors.send_mail : response.save_form,
                                };
                            } else if (response?.errors?.send_mail) {
                                alert_data = {
                                    type: 'alert:show',
                                    title: response.errors.send_mail,
                                };
                            } else {
                                $form.find(':input:not([type=hidden]):not(:checkbox)').val('');
                                $form.find('textarea').val('');
                                $form
                                    .find('input[type="checkbox"]')
                                    .prop('checked', false);

                                 alert_data = {
                                    type: 'alert:show',
                                    title: response.send_mail,
                                    success: true,
                                };

                                $('.js-cf-form__status').addClass('success');
                                $('.js-cf-form__status').show();
                                $('.js-cf-form__status span').html(
                                    response.status_msg
                                );
                            }
                            if (formOutputWrapper && formOutputWrapper.length > 0) {
                                showOutputWrapper(formOutputWrapper[0], alert_data);
                            }
                            $form.removeClass('is-loading');
                            if (formLoader) formLoader.classList.remove("active");
                        },
                    });
                });
        });
    });
})(jQuery);
